import { InjectionToken, Provider } from "@angular/core";

// eslint-disable-next-line @tseslint/typedef
export const SORT_DIRECTIONS = {
  NO_SORT: "no-sort",
  ASCENDING: "asc",
  DESCENDING: "desc"
} as const;
export type SortDirection = typeof SORT_DIRECTIONS[keyof typeof SORT_DIRECTIONS];
// eslint-disable-next-line @tseslint/no-explicit-any, @tseslint/explicit-module-boundary-types
export function isSortDirection (value: any): value is SortDirection {
  return value === SORT_DIRECTIONS.ASCENDING || value === SORT_DIRECTIONS.DESCENDING;
}

const DEFAULT_SORT_DIRECTION_ORDER: SortDirection[] = [ SORT_DIRECTIONS.NO_SORT, SORT_DIRECTIONS.ASCENDING, SORT_DIRECTIONS.DESCENDING ];

/**
 * Default sort direction used when no specific sort direction is provided.
 */
export const DEFAULT_SORT_DIRECTION: SortDirection = SORT_DIRECTIONS.NO_SORT;
/**
 * Injection token for configuring the sort direction order.
 */
export const SORT_DIRECTION_ORDER: InjectionToken<SortDirection[]> = new InjectionToken<SortDirection[]>("SortDirectionOrder");
/**
 * Factory function that returns a provider for the sort direction order.
 *
 * If a custom sort direction order is provided, it is used; otherwise, the default order is applied.
 *
 * @param sortDirection - An optional custom array of sort directions.
 * @returns A provider that supplies the SORT_DIRECTION_ORDER token with the specified or default sort order.
 */
export function provideSortDirectionOrder (sortDirection: SortDirection[] | undefined = undefined): Provider {
  return {
    provide: SORT_DIRECTION_ORDER,
    useValue: sortDirection ?? DEFAULT_SORT_DIRECTION_ORDER
  };
}
